/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import ContactCard from '../../components/ContactCard';
import TitleBox from '../../components/TitleBox';
import { TestIds } from '../../testIds';
import { selectContactInfo } from '../azure-b2c/storage';
import { Box } from '@mui/material';

const NoSalesAgreement = ({
  display,
  body,
  contactTitle,
}: {
  display?: string;
  body: string;
  contactTitle?: string;
}) => {
  const relationshipOwner = useSelector(selectContactInfo);

  return (
    <Box display={'flex'} flexDirection={'column'} gap={3}>
      <TitleBox
        data-testid={TestIds.feat.agreement.list.noAgreementsMessage}
        display={display}
        body={body}
      />
      {contactTitle && (
        <ContactCard
          data-testid={TestIds.feat.agreement.list.noAgreementsContactBox}
          title={contactTitle}
          {...relationshipOwner}
        />
      )}
    </Box>
  );
};

export default NoSalesAgreement;
